export const KeyCodes = { Wo: 32, Ao: 9, Xo: 13, _h: 27 };
